// extracted by mini-css-extract-plugin
export default {"not_available_message":"_115O","not_available_text":"_1CoK"};